module.exports = __webpack_public_path__ + "img/360-matrum 2.e4b207ee.jpg";